import type { CSSProperties } from "react";

// Мелочи оформления списков версий в панели и на странице истории.

export const sectionTitleStyle: CSSProperties = {
  fontSize: 10.5,
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "var(--fg-2)",
};
